<template>
  <div class="header-right">
    <div
      class="header-search"
      v-click-outside="
        () => {
          showDropdown = false;
        }
      "
    >
      <a href="#" class="search-toggle" role="button"
        ><i class="icon-search"></i
      ></a>

      <div class="header-search-wrapper">
        <label for="q" class="sr-only">Search</label>
        <input
          type="search"
          v-model="searchText"
          placeholder="Search product ..."
          style="width: 480px"
          class="form-control"
          @focus="showDropdown = true"
          @keyup.enter="btnSearchProduct"
          required
        />
      </div>

      <div
        v-if="showDropdown"
        id="dropdown-list"
        class="list-group position-absolute overflow-auto text-start"
      >
        <span
          v-if="loading"
          class="list-group-item list-group-item-action disabled"
          tabindex="-1"
          aria-disabled="true"
        >
          <div class="spinner-border text-info" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </span>
        <template v-if="products && products.length">
          <router-link
            v-for="(product, Idx) in products"
            :key="`product-${Idx}`"
            :to="{
              name: 'Detail',
              query: { productId: product.Id },
            }"
            class="list-group-item list-group-item-action"
            @click.native="showDropdown = false"
          >
            <div
              class="col-2"
              style="
                height: 50px;
                overflow: hidden;
                position: relative;
                float: left;
              "
            >
              <img
                v-if="product.imagePath"
                v-lazy="product.imagePath"
                :data-srcset="product.imagePath"
                class="product-image"
                style="width: 100%; height: auto"
              />
              <img
                v-else
                src="static/images/no-photo.svg"
                style="width: 100%"
              />
            </div>

            <div
              class="col-10"
              style="float: right; text-align: left; line-height: 2rem"
            >
              <p>{{ product.Name }}</p>
            </div>
          </router-link>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import ClickOutside from "vue-click-outside";

export default {
  name: "SearchBox",
  data() {
    return {
      loading: false,
      products: [],
      searchText: null,
      showDropdown: false,
    };
  },
  directives: {
    ClickOutside,
  },
  computed: {
    keywords() {
      return this.$route.query.keywords;
    },
  },
  watch: {
    async searchText(val) {
      await this.searchProduct(val);
    },
    keywords(val) {
      this.searchText = val;
    },
  },
  methods: {
    btnSearchProduct() {
      if (this.searchText) {
        this.$router
          .push({
            name: "List",
            query: {
              keywords: this.searchText,
            },
          })
          .catch(() => {});
      }
    },
    async searchProduct(search) {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(async () => {
        let results = [];

        if (search) {
          this.loading = true;
          try {
            let filters = [];
            filters.push(`Status eq ${this.$const.STATUS.Active}`);

            let orFilters = [];
            isNaN(search) &&
              orFilters.push(`contains(Name, '${search.trim()}')`);
            !isNaN(search) &&
              orFilters.push(`contains(ItemNumber, '${search.trim()}')`);
            !isNaN(search) &&
              orFilters.push(`contains(DrawingCode, '${search.trim()}')`);
            !isNaN(search) &&
              orFilters.push(`contains(EanCode, '${search.trim()}')`);

            if (orFilters.length) {
              filters.push(`(${orFilters.join(" or ")})`);
            }

            results = await this.loadProducts(filters.join(" and "));
          } catch (error) {
            alert(error);
          }
          this.loading = false;
        }

        this.products = results;
      }, 1000);
    },
    async loadProducts(filter) {
      let results = [];
      let resp = await this.$http.get(`odata/LsgProductNew`, {
        params: {
          //$top: 10,
          $filter: filter,
        },
      });
      if (resp && resp.status == 200 && resp.data.value.length) {
        results = resp.data.value
          ? await Promise.all(
              resp.data.value.map(async (_) => {
                let imagePath = "";
                if (_.ProductImage) {
                  let images = JSON.parse(_.ProductImage);

                  let mainImage = images.find((img) => img.IsMain);
                  imagePath = await this.$func.getMainImagePath(mainImage);
                }
                _.imagePath = imagePath;

                return _;
              })
            )
          : [];
      }
      return results;
    },
  },
};
</script>

<style scoped>
#dropdown-list {
  max-height: 300px;
  z-index: 12;
  width: 440px;
  left: -227px;
  top: 36px;
}
</style>



// WEBPACK FOOTER //
// src/components/SearchBox.vue